// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,

  // apiUrl: "http://52.15.152.26:9051",
  // baseUrl: "http://52.15.152.26:9051",
  // serverAPI: "http://52.15.152.26:9051",
  // AUTH_URL: "http://52.15.152.26:9051",
  // uraUrl: "http://52.15.152.26:9051",
  // authUrl: "http://52.15.152.26:9051",

  // baseUrl: "http://52.15.152.26:1905",

  // baseUrl: "http://127.0.0.1:9090",

  //apiUrl: 'http://52.15.152.26:6300'
  
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
